'use strict';
var BaggagesSelectorDescriptorsCollection = Backbone.Collection.extend({
    model: require('../models/baggage_row'),
    BAGGAGE_TYPE: {
        notAllowed: 'NOT_ALLOWED',
        included: 'INCLUDED',
        includedSelectable: 'INCLUDED_SELECTABLE',
        selectable: 'SELECTABLE',
    },
    TRANSPORT_TYPE: {
        airplane: 'PLANE',
        train: 'TRAIN',
    },
    APPLICATION_LEVEL: {
        itinerary: 'ITINERARY',
        segment: 'SEGMENT',
        section: 'SECTION',
    },
    REQUEST_TYPE: {
        oneWay: 'ONE_WAY',
        roundTrip: 'ROUND_TRIP',
        multiTrip: 'MULTIPLE_DESTINATIONS',
    },
    requestType: '',
    allowAutoselection: null,
    allowSmartNag: null,
    allSelectable: null,
    allSameCarrier: null,
    autoSelectionEnabled: false,
    baggageBundleDiscountPercentage: 0,
    ROW_IDS: ['FIRST', 'SECOND', 'THIRD', 'FOURTH', 'FIFTH', 'SIXTH'],
    baggage_row_ids: [],
    fillData: function(baggagesRowInfo, metas) {
        var parsedData;

        if (Odigeo._.isNaN(metas.idPassenger)) {
            return;
        }

        parsedData = {
            idPassenger: metas.idPassenger,
            idRow: metas.idRow,
            hasIncludedBaggages: metas.hasIncludedBaggages,
            hasSelectableBaggages: metas.hasSelectableBaggages,
            shouldDisplayGenericLogo: metas.shouldDisplayGenericLogo,
            carrierCode: baggagesRowInfo.carrier.code,
            commercialBrandCode: baggagesRowInfo.allCommercialBrands.length > 0 ? baggagesRowInfo.allCommercialBrands[0].code : '',
            departureCity: baggagesRowInfo.departureLocation.city,
            departureCityIata: baggagesRowInfo.departureLocation.cityIataCode,
            departureIata: baggagesRowInfo.departureLocation.iata,
            arrivalCity: baggagesRowInfo.arrivalLocation.city,
            arrivalCityIata: baggagesRowInfo.arrivalLocation.cityIataCode,
            arrivalIata: baggagesRowInfo.arrivalLocation.iata,
            transportType: baggagesRowInfo.transportType,
            baggageApplicationLevel: baggagesRowInfo.baggageApplicationLevel,
            baggageFeeIncludedInPrice: baggagesRowInfo.baggageFeeIncludedInPrice,
            baggagePropensity: baggagesRowInfo.baggagePropensity,
            debugInfo: baggagesRowInfo.debugInfo,
        };

        this.add(parsedData);

        this.baggage_row_ids = Odigeo._.union(this.baggage_row_ids, [metas.idRow]);
    },
    setBaggageBundleDiscountPercentage: function(baggageBundleDiscountPercentage) {
        this.baggageBundleDiscountPercentage = baggageBundleDiscountPercentage;
    },
    clearCollection: function() {
        this.remove(this.models);
    },
    getBaggageBundleDiscountPercentage: function() {
        return this.baggageBundleDiscountPercentage;
    },
    getRow: function(searchPattern) {
        return this.findWhere(searchPattern);
    },
    getRows: function(searchPattern) {
        return this.where(searchPattern);
    },
    getRowIds: function() {
        return this.baggage_row_ids;
    },
    getPassengerRows: function(idPassenger) {
        return this.getRows({
            idPassenger: idPassenger,
        });
    },
    getPassengerIncludedAndSelectableRows: function(idPassenger) {
        return this.getRows({
            idPassenger: idPassenger,
            hasIncludedBaggages: true,
            hasSelectableBaggages: true,
        });
    },
    getPassengerIncludedAndNoSelectableRows: function(idPassenger) {
        return this.getRows({
            idPassenger: idPassenger,
            hasIncludedBaggages: true,
            hasSelectableBaggages: false,
        });
    },
    getPassengerSelectableRows: function(idPassenger) {
        return this.getRows({
            idPassenger: idPassenger,
            hasSelectableBaggages: true,
        });
    },
    setRequestType: function(type) {
        if (Odigeo._.contains(Odigeo._.values(this.REQUEST_TYPE), type)) {
            this.requestType = type;
        }
    },
    getRequestType: function() {
        return this.requestType;
    },
    setAutoSelectionEnabled: function(enabled) {
        this.autoSelectionEnabled = enabled;
    },
    isAutoSelectionEnabled: function() {
        return this.autoSelectionEnabled;
    },
    areAllLegsSelectable: function() {
        var selectableRows;

        if (Odigeo._.isNull(this.allSelectable)) {
            selectableRows = this.getRows({hasSelectableBaggages: true});
            this.allSelectable = selectableRows.length === this.length;
        }

        return this.allSelectable;
    },
    shouldDisplayGenericLogo: function() {
        return this.getRows({shouldDisplayGenericLogo: true}).length > 0;
    },
    doRowsAllowAutoselection: function() {
        var isRequestRoundTrip;

        if (Odigeo._.isNull(this.allowAutoselection)) {
            isRequestRoundTrip = this.requestType === this.REQUEST_TYPE.roundTrip;

            this.allowAutoselection = isRequestRoundTrip && this.areAllLegsSelectable();
        }

        return this.allowAutoselection;
    },
    doRowsAllowSmartNag: function() {
        var isRequestOneWayOrRoundTrip;
        if (Odigeo._.isNull(this.allowSmartNag)) {
            isRequestOneWayOrRoundTrip = this.isOneWayTrip() || this.requestType === this.REQUEST_TYPE.roundTrip;
            this.allowSmartNag = isRequestOneWayOrRoundTrip && this.areAllLegsSelectable();
        }

        return this.allowSmartNag;
    },
    isRoundTrip: function() {
        return this.requestType === this.REQUEST_TYPE.roundTrip;
    },
    isAnItineraryTrip: function() {
        const isRoundTrip = this.requestType === this.REQUEST_TYPE.roundTrip;
        const isMultiTrip = this.requestType === this.REQUEST_TYPE.multiTrip;
        const baggageRows = this.toJSON();
        const itineraryAsApplicationLevelForAllBaggageRows = Odigeo._.every(baggageRows, function(row) {
            return row.baggageApplicationLevel === this.APPLICATION_LEVEL.itinerary;
        }, this);

        return (isRoundTrip || isMultiTrip) && itineraryAsApplicationLevelForAllBaggageRows;
    },
    isOneWayTrip: function() {
        return this.requestType === this.REQUEST_TYPE.oneWay;
    },
});
var instance;

module.exports.getInstance = function() {
    if (Odigeo._.isUndefined(instance)) {
        instance = new BaggagesSelectorDescriptorsCollection();
    }
    return instance;
};
